import { Dialog } from "primereact/dialog";
import React, { useEffect } from "react";
import { srcImagesFile } from "../../../utilities/FileUtil";

export default function P105DialogViewPic({ dialog, setDialogPic, data }) {
    return (
        <Dialog header="รูปถ่าย" visible={dialog.dialog} style={{ width: "50vw" }} className="p-fluid ___widthDialog" onHide={() => setDialogPic({ dialog: false, show: false })} blockScroll={true} className="p-fluid" maximizable={true}>
            {/* {dialog && dialog.show === true ? */}
            <img {...srcImagesFile(data)} width="100%" />
            {/* : null}*/}
        </Dialog>
    );
}
